import { AlertService } from '../../shared/services/alert.service';
import { OnInit, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Assessment } from "../../shared/models/assessment";
import { QuestionAnswerPopulator } from "../../shared/services/question-answer-populator.service";
var AssessmentComponent = /** @class */ (function () {
    function AssessmentComponent(alertService, questionPopulator) {
        this.alertService = alertService;
        this.questionPopulator = questionPopulator;
        this.onSubmit = new EventEmitter();
        this._currentIndex = 0;
        this._maxQuestionSetsIndex = 0;
        this._currentAssessmentId = null;
        this._showInstructions = true;
    }
    AssessmentComponent.prototype.ngOnInit = function () { };
    AssessmentComponent.prototype.ngOnChanges = function (changes) {
        // we've changed assessments, so recalculate our index here.
        if (this.assessment && this._currentAssessmentId != this.assessment.id) {
            this._currentAssessmentId = this.assessment.id;
            this._displayQuestionSets = this.getQuestionSetsForDisplay(this.assessment);
            var qs = this._displayQuestionSets.length ? this._displayQuestionSets[0] : null;
            if (qs !== null) {
                this.setCurrentQuestionSet(qs);
            }
            this.calculateDisplayIndexesForQuestions(this.assessment);
        }
    };
    AssessmentComponent.prototype.getQuestionSetsForDisplay = function (assessment) {
        return assessment.getQuestionSetsForDisplay();
    };
    AssessmentComponent.prototype.getNextQuestionSetToDisplay = function (assessment, currentQuestionSet) {
        return assessment.getNextQuestionSetToDisplay(currentQuestionSet);
    };
    AssessmentComponent.prototype.getPreviousQuestionSetToDisplay = function (assessment, currentQuestionSet) {
        return assessment.getPreviousQuestionSetToDisplay(currentQuestionSet);
    };
    AssessmentComponent.prototype.calculateDisplayIndexesForQuestions = function (assessment) {
        var display_index = 1;
        this._displayQuestionSets.forEach(function (qs) { qs.questions.forEach(function (q) { q.display_index = display_index++; }); });
    };
    Object.defineProperty(AssessmentComponent.prototype, "maxQuestionSetsIndex", {
        get: function () {
            if (this.assessment) {
                var sets = this._displayQuestionSets;
                return sets.length - 1 > 0 ? sets.length - 1 : 0;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentComponent.prototype, "currentIndex", {
        get: function () {
            var sets = this._displayQuestionSets || [];
            return sets.indexOf(this.currentQuestionSet);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentComponent.prototype, "currentQuestionSet", {
        get: function () {
            return this._currentQuestionSet;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentComponent.prototype.setCurrentQuestionSet = function (qs) {
        if (qs !== this._currentQuestionSet
            && qs.instructions) {
            // Since the new question set instructions changed, let's make sure to show
            // our instructions again...
            this.showInstructions();
        }
        this._currentQuestionSet = qs;
        // we have some scrolling issues so let's fix that.
        window.scrollTo(0, 0);
    };
    AssessmentComponent.prototype.nextSet = function () {
        if (this.hasUnansweredQuestions()) {
            // display an alert
            this.alertService.error("Please answer all of the questions before proceeding");
            return;
        }
        var qs = this.getNextQuestionSetToDisplay(this.assessment, this.currentQuestionSet);
        this._displayQuestionSets = this.getQuestionSetsForDisplay(this.assessment); // update the question set
        this.setCurrentQuestionSet(qs);
        // we recalculate the question numbering since a current question set can trigger another question set to display
        this.calculateDisplayIndexesForQuestions(this.assessment);
    };
    AssessmentComponent.prototype.hasUnansweredQuestions = function () {
        var unAnsweredQuestions = this.currentQuestionSet.questions.filter(function (q) { return !q.isFilledOut; });
        return unAnsweredQuestions.length > 0;
    };
    Object.defineProperty(AssessmentComponent.prototype, "hasNextSet", {
        get: function () {
            if (!this.assessment) {
                return false;
            }
            var qs = this.getNextQuestionSetToDisplay(this.assessment, this.currentQuestionSet);
            return qs != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentComponent.prototype, "hasPreviousSet", {
        get: function () {
            if (!this.assessment) {
                return false;
            }
            var qs = this.getPreviousQuestionSetToDisplay(this.assessment, this.currentQuestionSet);
            return qs != null;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentComponent.prototype.previousSet = function () {
        var qs = this.getPreviousQuestionSetToDisplay(this.assessment, this.currentQuestionSet);
        this._displayQuestionSets = this.getQuestionSetsForDisplay(this.assessment); // update the question set
        this.setCurrentQuestionSet(qs);
        this.calculateDisplayIndexesForQuestions(this.assessment);
        // let index = Math.max(this.currentIndex - 1, 0);
        // this.setCurrentSetForIndex(index);
    };
    AssessmentComponent.prototype.hasInstructions = function () {
        if (this.assessment && this.assessment.instructions) {
            return true;
        }
        if (this.currentQuestionSet && this.currentQuestionSet.instructions) {
            return true;
        }
        return false;
    };
    AssessmentComponent.prototype.shouldShowInstructions = function () {
        return this._showInstructions;
    };
    AssessmentComponent.prototype.showInstructions = function () {
        this._showInstructions = true;
    };
    AssessmentComponent.prototype.hideInstructions = function () {
        this._showInstructions = false;
    };
    AssessmentComponent.prototype.selectSample = function () {
        var _this = this;
        var qs = this.assessment.getFirstQuestionSetToDisplay();
        if (qs == null) {
            return;
        }
        do {
            qs.questions.forEach(function (q) { return _this.questionPopulator.populateQuestion(q, qs); });
            qs = this.getNextQuestionSetToDisplay(this.assessment, this.currentQuestionSet);
        } while (qs !== null);
    };
    AssessmentComponent.prototype.submit = function () {
        if (this.hasUnansweredQuestions()) {
            this.alertService.error("Please answer all of the questions before submitting");
            return;
        }
        this.onSubmit.emit(this.assessment);
    };
    return AssessmentComponent;
}());
export { AssessmentComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/assessment/assessment.component.ts.pre-build-optimizer.js